<template>
    <div class="sidebar" :class="sidebarClasses">
        <slot />
    </div>
</template>
<script>
    export default {
        data() {
            return {
                show: false,
            };
        },
        computed: {
            sidebarClasses() {
                if (this.show) {
                    return;
                }

                return [
                    'hidden md:flex',
                ];
            },
        },
        created() {
            EventBus.$on('toggle-admin-sidebar', () => {
                this.show = ! this.show;
            });
        },
    };
</script>
